import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonTagsField from '../../../common/fields/TagsField';
import { ArtsAndCraftsDeviationFieldName } from '../../types';

interface Props {
  noBottomSpacing?: boolean;
}

const TagsField: React.FC<Props> = ({ noBottomSpacing }) => {
  const { t } = useTranslation();

  return (
    <CommonTagsField
      fieldName={ArtsAndCraftsDeviationFieldName.TAGS}
      label={t('artsAndCraftsDeviationPopup.form.tags.label')}
      placeholder={t('artsAndCraftsDeviationPopup.form.tags.placeholder')}
      noBottomSpacing={noBottomSpacing}
    />
  );
};
TagsField.displayName = 'TagsField';

export default TagsField;
